import { Component, ElementRef, inject, input, output, signal } from '@angular/core';
import { FeatherIconsComponent } from '../../feather-icons/feather-icons.component';

export interface UserAccount {
  name: string;
  email: string;
  avatarUrl: string;
}

@Component({
  selector: 'app-account-sidebar',
  standalone: true,
  imports: [FeatherIconsComponent],
  templateUrl: './account-sidebar.component.html',
  host: {
    '(document:click)': 'onDocumentClick($event)',
    '(document:keydown.escape)': 'closeMenu()',
  },
})
export class AccountSidebarComponent {
  protected readonly ui = {
    navButton:
      'flex w-full cursor-pointer items-center rounded-[8px] border-0 bg-transparent px-4 py-2 text-left text-ink ' +
      'transition-[background-color] duration-150 ease-css hover:bg-hover',
    icon20: 'flex size-5 items-center justify-center text-[20px] leading-5',
    navIcon: 'flex size-5 items-center justify-center text-[20px] leading-5 text-ink',
    navLabel: 'text-[15px] leading-[1.2] font-normal',
    menuTrigger: 'btn inline-flex size-9 items-center justify-center p-0 text-ink-soft hover:bg-hover hover:text-ink',
    menu: 'absolute bottom-full z-[1000] mb-0.5 min-w-40 list-none rounded border border-[rgba(0,0,0,0.15)] bg-white py-2 text-left text-bs-body shadow-sm',
    menuItem:
      'flex w-full items-center border-0 bg-transparent py-1 pr-6 pl-2 text-left text-[14px] font-normal whitespace-nowrap text-bs-body ' +
      'hover:bg-[#f8f9fa] hover:text-[#16181b] active:bg-primary active:text-white',
  } as const;

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  collapseSidebar = input<boolean>(false);

  // Signal Inputs
  user = input<UserAccount>({
    name: 'Shadcn',
    email: 'm@example.com',
    avatarUrl: 'assets/images/user/user.png',
  });

  // Signal Outputs for Navigation & Actions
  settingsClick = output<void>();
  getHelpClick = output<void>();
  searchClick = output<void>();
  viewProfile = output<void>();
  logout = output<void>();

  protected menuOpen = signal(false);

  protected toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  protected closeMenu(): void {
    this.menuOpen.set(false);
  }

  protected onDocumentClick(event: Event): void {
    if (this.menuOpen() && !this.host.nativeElement.contains(event.target as Node)) {
      this.closeMenu();
    }
  }

  protected onViewProfile(): void {
    this.closeMenu();
    this.viewProfile.emit();
  }

  protected onLogOut(): void {
    this.closeMenu();
    this.logout.emit();
  }
}
